import { useLang } from "@/i18n/LangContext";
import { MapPin } from "lucide-react";

export default function LocationMap() {
  const { t } = useLang();
  const mapsUrl =
    "https://www.google.com/maps/search/?api=1&query=Via+Donizetti+9+Loano+SV+Italy";
  const embedSrc =
    "https://www.google.com/maps?q=Via+Donizetti+9,+17025+Loano+SV,+Italy&output=embed";

  return (
    <section
      id="map"
      data-testid="map-section"
      className="py-24 sm:py-32 bg-[#F0EDE6]"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="grid lg:grid-cols-12 gap-10 items-end mb-12">
          <div className="lg:col-span-7">
            <p className="text-xs uppercase tracking-overline text-[#0097b2] mb-4">
              {t.map.overline}
            </p>
            <h2 className="font-serif text-4xl md:text-5xl tracking-tight text-[#121C26]">
              {t.map.title}
            </h2>
          </div>
          <div className="lg:col-span-5 lg:text-right">
            <a
              data-testid="open-maps-btn"
              href={mapsUrl}
              target="_blank"
              rel="noreferrer"
              className="inline-flex items-center px-6 py-3 rounded-full bg-[#1A3B4D] text-[#FAF9F6] text-sm tracking-wide hover:bg-[#102632] transition-colors"
            >
              <MapPin size={16} strokeWidth={1.5} className="mr-2" />
              {t.map.cta}
            </a>
          </div>
        </div>

        <div
          className="w-full aspect-[16/9] border border-[#E0DACE] overflow-hidden"
          data-testid="map-embed"
        >
          <iframe
            title="Map"
            src={embedSrc}
            width="100%"
            height="100%"
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
            style={{ border: 0 }}
          />
        </div>
      </div>
    </section>
  );
}
